/** @module Apparel/NewColorMaterialForm **/
define([
		"dojo/_base/declare",
		"./_ColorMaterialFormMixin"
], function(declare,_ColorMaterialFormMixin) {

	return declare(_ColorMaterialFormMixin, {});
});
